import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Optics() {
  useDocumentMeta('Hunting & Shooting Optics in Lake Benton, Minnesota | Kjergaard Sports', 'Shop scopes, binoculars, spotting scopes, rangefinders, and optics options for hunters and target shooters at Kjergaard Sports in Lake Benton, Minnesota.');
  const categories = ['Scopes', 'Binoculars', 'Spotting scopes', 'Rangefinders', 'Rifle scopes', 'Shotgun scopes', 'Pistol optics', 'Hunting optics', 'Target shooting optics'];
  return <div data-id="element-450">
      <PageHero title="Hunting & Shooting Optics" image="https://cdn.magicpatterns.com/uploads/1zvBEqUZKRM4BZCWhxgmNi/optics-cases.jpg" alt="Scopes and optics available at Kjergaard Sports" data-id="element-451" />

      <section className="py-20 bg-brand-offwhite" data-id="element-452">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-453">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-454">
            <div data-id="element-455">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-456">
                Clear Vision for the Field and Range
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-457">
                A quality firearm deserves quality glass. Kjergaard Sports
                carries a wide selection of optics for every application, from
                long-range precision shooting to dense-woods deer hunting.
              </p>
              <p className="text-lg text-brand-charcoal/80 mb-8 leading-relaxed" data-id="element-458">
                Our knowledgeable staff can help you compare reticles,
                magnification ranges, and glass clarity in person, ensuring you
                select the right optic for your specific needs.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream mb-8" data-id="element-459">
                <h3 className="font-serif text-xl mb-4" data-id="element-460">
                  Our Optics Selection Includes:
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-461">
                  {categories.map((item, index) => <li key={index} className="flex items-start" data-id="element-462">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-463" />
                      <span className="text-brand-charcoal/90" data-id="element-464">{item}</span>
                    </li>)}
                </ul>
              </div>

              <Link to="/contact" className="inline-flex bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors items-center" data-id="element-465">
                <MapPin className="w-5 h-5 mr-2" data-id="element-466" />
                Visit the Store for In-Person Help
              </Link>
            </div>

            <div data-id="element-467">
              <img src="https://cdn.magicpatterns.com/uploads/1zvBEqUZKRM4BZCWhxgmNi/optics-cases.jpg" alt="Optics selection at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-468" />
            </div>
          </div>
        </div>
      </section>
    </div>;
}